module.exports = __webpack_public_path__ + "static/bernie_pups-373d446911c149cf339b67a85c51b4e9.mp4";